import { firebaseAuth } from './firebaseClient';

const BASE_URL = process.env.REACT_APP_CLOUD_RUN_URL ?? '';

export async function callCloudRun<T = unknown>(path: string, body: object = {}, timeoutMs = 10000): Promise<T> {
  const user = firebaseAuth.currentUser;
  if (!user) {
    console.error(`[callCloudRun] No Firebase user for ${path}`);
    throw new Error('No active session — please sign out and sign back in');
  }

  const token = await user.getIdToken();

  const controller = new AbortController();
  const timeoutId = setTimeout(
    () => controller.abort(new Error(`[callCloudRun] Timed out after ${timeoutMs}ms for ${path}`)),
    timeoutMs
  );

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
      signal: controller.signal,
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({})) as { error?: string };
      throw new Error(err.error ?? `HTTP ${res.status}`);
    }

    return res.json() as Promise<T>;
  } finally {
    clearTimeout(timeoutId);
  }
}
